import { useEffect, useState } from "react";

// Loading overlay component - stays visible until Canvas renders first frame
// Uses CSS animations for smooth progress (not blocked by JS thread)
export default function LoadingOverlay({ isReady }) {
  const [show, setShow] = useState(true);

  // Fade out when scene is actually ready (first frame rendered)
  useEffect(() => {
    if (isReady) {
      const timer = setTimeout(() => setShow(false), 600);
      return () => clearTimeout(timer);
    }
  }, [isReady]);

  if (!show) return null;

  return (
    <div
      className="pointer-events-none absolute inset-0 flex flex-col items-center justify-center bg-[#15151a]/40 backdrop-blur-md transition-opacity duration-700"
      // Above drei <Html> content (speech bubble, project frames), which
      // uses z-index values in the 16-million range - but below the nav
      // menu, which stays sharp and clickable over the blur.
      style={{ opacity: isReady ? 0 : 1, zIndex: 2147483646 }}
    >
      <style>{`
        @keyframes progress-fill {
          0% { width: 0%; }
          100% { width: 92%; }
        }
        @keyframes progress-complete {
          0% { width: 92%; }
          100% { width: 100%; }
        }
        .progress-bar-animated {
          animation: progress-fill 5s ease-out forwards;
        }
        .progress-bar-complete {
          animation: progress-complete 0.3s ease-out forwards;
        }
      `}</style>

      <div className="flex flex-col items-center gap-6">
        {/* Loading text */}
        <div className="text-center">
          <p className="font-mono text-xl font-medium text-white">
            Loading 3D models...
          </p>
        </div>

        {/* Progress bar - uses pure CSS animation */}
        <div className="h-2 w-64 overflow-hidden rounded-full bg-white/10">
          <div
            className={`h-full bg-gradient-to-r from-[#dda0dd] via-[#ff6c9d] to-[#eaff7f] ${isReady ? "progress-bar-complete" : "progress-bar-animated"}`}
          />
        </div>
      </div>
    </div>
  );
}
